export default {
  index(params = {}) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/staffs', {
      params,
    });
  },
  list() {
    return axios.get(import.meta.env.VITE_SITE_URL + '/staffs?list');
  },
  getStaff(payload) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/staffs/' + payload.id);
  },
  showStaff(id) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/staffs/' + id);
  },
  store(staff) {
    staff = JSON.parse(JSON.stringify(staff));
    staff.employee.id = 0;
    staff.employee.person.id = 0;
    staff.employee.person.personaddress.id = 0;
    staff.employee.person.personbankaccount.id = 0;
    return axios.post(import.meta.env.VITE_SITE_URL + '/staffs', { staff });
  },
  update(staff) {
    staff = JSON.parse(JSON.stringify(staff));
    staff.employee.person.company.address = staff.employee.person.company.address && staff.employee.person.company.address.id ? staff.employee.person.company.address.id : {};
    return axios.put(import.meta.env.VITE_SITE_URL + '/staffs/' + staff.id, { staff: staff });
  },
  getVersions(original) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/staffs/versions/' + original);
  },
  getRates(year, month) {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/staffs/get/rates`, { year, month });
  },
  PAYROLL: {
    index(url = '') {
      return axios.get(import.meta.env.VITE_SITE_URL + '/staffs/payrolls' + url);
    },
    generateIndividualPaymentList(agreementId) {
      return axios.post(import.meta.env.VITE_SITE_URL + '/staffs/payrolls/generate/' + agreementId);
    },
    destroy(id) {
      return axios.delete(import.meta.env.VITE_SITE_URL + '/staffs/payrolls/' + id);
    },
  },
  PAYMENT: {
    store(payment) {
      return axios.put(import.meta.env.VITE_SITE_URL + '/staffs/payrolls/payments/' + payment.id, { payment });
    },
    calculate(payment) {
      return axios.post(import.meta.env.VITE_SITE_URL + '/staffs/payrolls/payments/calculate/' + payment.id, payment);
    },
    show(id) {
      return axios.get(import.meta.env.VITE_SITE_URL + '/staffs/payrolls/payments/' + id);
    },
    recalculate(id) {
      return axios.put(`${ import.meta.env.VITE_SITE_URL }/staffs/payrolls/payments/${ id }/regenerate`, []);
    },
    extendData(id) {
      return axios.get(import.meta.env.VITE_SITE_URL + '/staffs/payrolls/payments/extend-data/' + id);
    },
  },
  BILL: {
    index(url = '') {
      return axios.get(import.meta.env.VITE_SITE_URL + '/staffs/bills' + url);
    },
    generateBill(payload) {
      return axios.post(import.meta.env.VITE_SITE_URL + '/staffs/bills/generate/' + payload.agreementId, { bill: payload.data });
    },
    prepareGeneratorData(payload) {
      return axios.post(import.meta.env.VITE_SITE_URL + '/staffs/bills/prepare_generator_data', { bill: payload });
    },
  },
  ADDRESS: {
    index() {
      return axios.get(import.meta.env.VITE_SITE_URL + '/persons/addresses');
    },
    store(address) {
      address = { ...address };
      let person = JSON.parse(localStorage.getItem('person'));
      address.person = person.id;
      return axios.post(import.meta.env.VITE_SITE_URL + '/persons/addresses', { address: address });
    },
    show(id) {
      return axios.get(import.meta.env.VITE_SITE_URL + '/persons/addresses/' + id);
    },
    update(address) {
      return axios.put(import.meta.env.VITE_SITE_URL + '/persons/addresses/' + address.id, { address: address });
    },
    destroy(id) {
      return axios.delete(import.meta.env.VITE_SITE_URL + '/persons/addresses/' + id);
    },
  },
};
